export default "__VITE_ASSET__6510d436__"